import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import Admin from './pages/Admin';
import { useAuthStore } from './store/authStore';
import './App.css';

function App() {
  const { user, initializeUser } = useAuthStore();

  useEffect(() => {
    // Initialize user on app start
    initializeUser();
  }, [initializeUser]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen"
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Protected Routes */}
          {user && (
            <>
              <Route path="/profile" element={<Profile />} />
              <Route path="/orders" element={<Orders />} />
              {user.role === 'admin' && (
                <Route path="/admin" element={<Admin />} />
              )}
            </>
          )}
        </Routes>
      </motion.main>
      <Footer />
    </div>
  );
}

export default App;